<div *adaptLoading="!stepsByParent"
     class="child-sortable-container m-3"
     [ngClass]="{
        'is-editing': isEditing,
        'is-saving': isSaving,
        'no-drop': noDropAllowed,
    }">
    <div [id]="getSortableId(parentStep)"
         class="child-sortable"
         [nxtSortablejs]="childSteps"
         [config]="childSortableOptions"
         (init)="handleSortableJsInit()">
        @for (child of childSteps; track child) {
            <div class="child-step">
                <adapt-process-step-card class="child-card"
                                         [processStep]="child"
                                         [isEditing]="isEditing"
                                         (stepClick)="stepClick.emit($event)"></adapt-process-step-card>
                @if (child?.extensions?.isProcessStep) {
                    <div class="children-list step-children"
                         [ngClass]="{
                            'children-list-empty': !isEditing && child.childSteps.length === 0,
                        }">
                        @if (getStepsByParent(child); as grandchildren) {
                            <div [id]="getSortableId(child)"
                                 class="grandchild-sortable"
                                 [nxtSortablejs]="grandchildren"
                                 [config]="grandchildSortableOptions"
                                 (init)="handleSortableJsInit()">
                                @for (grandchildStep of grandchildren; track grandchildStep) {
                                    <div class="grandchild-step">
                                        <adapt-process-step-card [processStep]="grandchildStep"
                                                                 [isEditing]="isEditing"
                                                                 (stepClick)="stepClick.emit($event)"></adapt-process-step-card>
                                    </div>
                                }
                            </div>
                        }
                        @if (isEditing) {
                            <adapt-add-child-step [processMap]="processMap$ | async"
                                                  [parentStep]="child"
                                                  (stepAdded)="scrollElementIntoView($event)"></adapt-add-child-step>
                        }
                    </div>
                }
                @if (child?.extensions?.isProcessMapLink) {
                    <!-- This slightly awkward usage here is to get the loading spinner inside the list border, but hide it if
          there aren't any children. Something like let-linkChildren="getLinkChildren(child-linkedProcessMap) | async"
          at the top level and ngClass => linkChildren.length and *adaptLoading="!linkChildren" would be
          better but I haven't come across a way to do something like that -->
                    @let linkChildren = getLinkChildren(child?.linkedProcessMap) | async;
            <div [ngClass]="{
                        'children-list-empty': linkChildren?.length === 0,
                    }" class="children-list link-children">
                    <ng-container *adaptLoading="!linkChildren">
                        <!-- We don't allow editing of link children from directly -->
                        @for (linkChild of linkChildren; track linkChild) {
                            <adapt-process-step-card class="grandchild-step"
                                                     [processStep]="linkChild"
                                                     (stepClick)="stepClick.emit($event)"></adapt-process-step-card>
                        }
                    </ng-container>
            </div>
        }
    </div>
}
</div>
@if (!isEditing && childSteps.length === 0) {
    <div class="row flex-fill m-0">No process steps or role tasks to display.</div>
}

@if (isEditing) {
    <adapt-add-child-step [processMap]="processMap$ | async"
                          [parentStep]="parentStep"
                          (stepAdded)="scrollViewToRight()"
                          data-test="add-child-step"></adapt-add-child-step>
}
</div>
